// Section categories store content as "content refs": a movie (VideoMeta) as
// its id and a series as its negated id, because the two tables number
// independently and collide (movie #4 and series #4). Mirrors the backend's
// src/utils/contentRefs.js.

export const toSeriesRef = (id) => -Math.abs(Number(id));

export const isSeriesItem = (item) =>
  String(item?.content_type || "").toLowerCase() === "series";

export const contentRefOf = (item) =>
  isSeriesItem(item) ? toSeriesRef(item.id) : item?.id;

// The Experience Builder uses the ref as each card's `id`, so selecting,
// removing and reordering never mix up a movie and a series with the same id.
// The real id is kept in `content_id`. Safe to call twice.
export const withContentRef = (item) => {
  if (!item || item.content_id !== undefined) return item;
  return { ...item, content_id: item.id, id: contentRefOf(item) };
};
